import { Grid, TextField, IconButton } from '@material-ui/core';
import cx from 'classnames';
import {
  icon_send,
  icon_speach_bubble,
  logo,
  icon_upload_file,
  dashboard_lecture_1,
  dashboard_lecture_2,
  dashboard_lecture_3,
} from 'components/base/images';
import MuiButton from 'components/common/button/MuiButton';
import EscapeConvert from 'components/common/convert/EscapeConvert';
import MuiWrapper from 'components/common/input/MuiWrapper';
import CustomSpan from 'components/common/text/CustomSpan';
import CustomText from 'components/common/text/CustomText';
import T from 'components/common/text/T';
import { ProjectSocketContext } from 'contexts/ProjectSocketContext';
import useInput from 'lib/hooks/useInput';
import useKeyboard from 'lib/hooks/useKeyboard';
import { cutUrl } from 'lib/library';
import { useDidUpdateEffect, useShallowSelector } from 'lib/utils';
import _, { debounce, throttle } from 'lodash';
import moment from 'moment';
import React, { Fragment, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { color, paper } from 'styles/utils';
import GTranslateIcon from '@material-ui/icons/GTranslate';
import { ENV_MODE_DEV } from 'lib/setting';
import axios from 'axios';
import { UtilActions, ProjectActions } from 'store/actionCreators';
import { axs } from 'api/config/axiosConfig';
import { fetchGoogleTranslate } from 'api/util';
import { useShallowAppSelector } from 'store/hooks';
import { ENV_MODE_PROD } from 'lib/setting';
import useMultiFileInput from 'lib/hooks/useMultiFileInput';
import { v4 as uuid } from 'uuid';
import ImagePopupSlick from 'components/util/ImagePopupSlick';

interface ImagePopupContainerProps {
  isShowChat: boolean;
}

export default function ImagePopupContainer() {
  const { user, language, fetchChatFile, fetchChatFileSuccess } = useShallowAppSelector(state => ({
    user: state.user.user,
    language: state.base.language,
    fetchChatFile: state.project.fetchChatFile.data?.list,
    fetchChatFileSuccess: state.project.fetchChatFile.success,
  }));

  // const windowSize = useRef([window.innerWidth, window.innerHeight]);
  const history = useHistory();
  const { pathname } = useLocation();
  const winW = window.innerWidth;
  const winH = window.innerHeight;
  const [winWidth, setWinWidth] = useState<number>(window.innerWidth);
  const [winHeight, setWinHeight] = useState<number>(window.innerHeight);
  const [windowSize, setWindowSize] = useState([window.innerWidth, window.innerHeight]);
  const windowRef = useRef<HTMLElement | null>(null);

  const currentHost = window.location.protocol + '//' + window.location.host;
  const projectCode = cutUrl(pathname, 2);
  const imageId = cutUrl(pathname, 3);
  const [initImageIndex, setInitImageIndex] = useState<number | null>(null);

  useEffect(() => {
    setWinWidth(window.innerWidth);
    setWinHeight(window.innerHeight);
  }, [window.innerWidth, window.innerHeight]);

  // useEffect(() => {
  //   console.log('winHeight ______ ', winHeight);
  // }, [winHeight]);

  // useEffect(() => {
  //   console.log('winWidth ______ ', winWidth);
  // }, [winWidth]);

  // useEffect(() => {
  //   window.opener.postMessage({ result: 'success' }, currentHost);
  // }, [window]);

  useEffect(() => {
    // console.log('HDS] pathname ______ ', pathname);
    // console.log('HDS] pathname ______ ', cutUrl(pathname, 2));

    ProjectActions.fetch_chat_file_request({ projectCode: projectCode });
  }, [pathname]);

  // useEffect(() => {
  //   console.log('winWidth ______ ', windowSize.current[0]);
  //   console.log('winHeight ______ ', windowSize.current[1]);
  // }, [windowSize]);
  // const handlePostMessage = (e: any) => {
  //   console.log('handlePostMessage child ______ ', e);
  //   // console.info('[Bridge]handlePostMessage ________________ ', event);
  //   // if (
  //   //   event.origin == 'https://auth.doflab.com' ||
  //   //   event.origin == 'https://my.doflab.com' ||
  //   //   event.origin == 'http://15.164.27.98:27015' ||
  //   //   event.origin == 'http://localhost:3001'
  //   // ) {
  //   if (e.origin == window.location.protocol + '//' + window.location.host) {
  //     console.log('이거 맞냐? _____ ', window);
  //     window.opener.focus();
  //     window.focus();
  //   }
  // };
  // useEffect(() => {
  //   window.addEventListener('message', handlePostMessage);
  //   return () => {
  //     window.removeEventListener('message', handlePostMessage, false);
  //   };
  // }, []);

  useEffect(() => {
    const handleWindowResize = () => {
      // setWindowSize([window.innerWidth, window.innerHeight]);
      setWinWidth(window.innerWidth);
      setWinHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  });
  useDidUpdateEffect(() => {
    if (!fetchChatFileSuccess) return;
    // console.log('HDS] fetchChatFile ______ ', fetchChatFile);
    const findImageIdx = Number(
      fetchChatFile.findIndex((list: any) => {
        return list.imageId === imageId;
      }),
    );
    setInitImageIndex(findImageIdx);
  }, [fetchChatFileSuccess]);

  return (
    <StyledImagePopup
      data-component-name="ImagePopup"
      winWidth={winWidth}
      winHeight={winHeight}
      ref={windowRef}
    >
      <div className="imagePopup__container">
        {useMemo(() => {
          if (initImageIndex === null) return;
          return (
            <ImagePopupSlick
              data={fetchChatFile}
              // data={sliderList}
              winH={winHeight}
              winW={winWidth}
              // fileIdx={cutUrl(pathname, 3)}
              fileIdx={initImageIndex}
            />
          );
        }, [fetchChatFile, winHeight, winWidth, initImageIndex])}
      </div>
    </StyledImagePopup>
  );
}

const StyledImagePopup = styled.section<{ winWidth: number; winHeight: number }>`
  background-color: #f4f4f4;
  .imagePopup__container {
    width: ${({ winWidth }) => winWidth + 'px'};
    height: ${({ winHeight }) => winHeight + 'px'};
    padding: 0 0 40px 0;
  }
`;
